import React, { FunctionComponent } from 'react';
import Header from '@/components/typography/Header';
import LandingPageContentSection from '@/components/landingPages/LandingPageContentSection';
import FlightSearchFormOverlay from '@/components/layout/landingPages/FlightSearchFormOverlay';
import WeekForecastBar from '@/components/weather/WeekForecastBar';
import { IPrismicRichTextElement } from '@/pageGeneration/services/prismicApi/types';
import { IWeatherForecast } from '@/services/WeatherService';
import landingPageFlightSearchRequestFormValues from '@jetslash/market-frontend-shared-core/src/forms/flightSearchRequest/helpers/landingPageFlightSearchRequestFormValues';
import PrismicRichText from '@/components/design/PrismicRichText';

interface IProps {
  structureTitle?: IPrismicRichTextElement[];
  pageTitle?: string;
  flightSearchFormProps: {
    destinationName: string;
    destinationLocationAutocompleteId: string;
    startDate?: any;
    endDate?: any;
    originName?: string;
    originLocationAutocompleteId?: string;
  };
  weatherForecast?: IWeatherForecast;
}

const LandingPageHeaderContent: FunctionComponent<IProps> = ({
  structureTitle,
  pageTitle,
  flightSearchFormProps,
  weatherForecast,
}) => {
  let flightSearchFormValues;
  if (flightSearchFormProps) {
    flightSearchFormValues = landingPageFlightSearchRequestFormValues(
      flightSearchFormProps.destinationName,
      flightSearchFormProps.destinationLocationAutocompleteId,
      flightSearchFormProps.startDate,
      flightSearchFormProps.endDate,
      flightSearchFormProps.originName,
      flightSearchFormProps.originLocationAutocompleteId,
    );
  }
  return (
    <>
      <PrismicRichText items={structureTitle} color="white" />
      <Header level={1} color="white">
        {pageTitle}
      </Header>
      <LandingPageContentSection>
        <FlightSearchFormOverlay transparent initialFormValues={flightSearchFormValues} />
      </LandingPageContentSection>
      {weatherForecast?.daily?.data && (
        <LandingPageContentSection>
          <WeekForecastBar forecastDays={weatherForecast.daily.data} />
        </LandingPageContentSection>
      )}
    </>
  );
};

export default LandingPageHeaderContent;
